module.exports = __webpack_public_path__ + "img/5.c304f5c5.jpg";